export class AWSS3Image {
  file_name: string;
  url: string;
  key: string;
  last_modified: Date;
  size_KB: number;


  constructor(
    file_name = '',
    url = '',
    key = '',
    last_modified: Date = new Date(),
    size_KB = 0
  ) {
    this.file_name = file_name;
    this.url = url;
    this.key = key;
    this.last_modified = last_modified;
    this.size_KB = size_KB;
  }
}
